/**
 * Remembers the assistant's mode, side-panel width and drawer rect in this browser.
 * Best effort only: localStorage can be missing or throw (privacy modes, blocked site data), and
 * a storage failure must never stop the assistant, it only stops it remembering.
 */
import { ASSISTANT_STORAGE_KEY } from '@Assistant/constants/assistant.constants';

/** @returns {{ mode?: string, panelWidth?: number, drawerRect?: { x: number, y: number, w: number, h: number } }} */
export function readGeometry() {
  try {
    const raw = window.localStorage.getItem(ASSISTANT_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (err) {
    return {};
  }
}

/** @param {{ mode?: string, panelWidth?: number, drawerRect?: object|null }} geometry */
export function writeGeometry(geometry) {
  try {
    window.localStorage.setItem(ASSISTANT_STORAGE_KEY, JSON.stringify(geometry));
  } catch (err) {
    // Storage unavailable: the assistant simply won't remember its size next time.
  }
}
